import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useReducedMotion } from '../../../theme/hooks.js';
import type { IconProps } from '../../primitives/types.js';

export function IcnSun(props: IconProps): ReactNode {
  const reduced = useReducedMotion();
  return (
    <Svg {...props} iconName="sun">
      <g>
        {!reduced && (
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 8 8"
            to="360 8 8"
            dur="16s"
            repeatCount="indefinite"
          />
        )}
        <line x1="8" y1="1.5" x2="8" y2="3.5" />
        <line x1="8" y1="12.5" x2="8" y2="14.5" />
        <line x1="1.5" y1="8" x2="3.5" y2="8" />
        <line x1="12.5" y1="8" x2="14.5" y2="8" />
        <line x1="3.2" y1="3.2" x2="4.6" y2="4.6" />
        <line x1="11.4" y1="11.4" x2="12.8" y2="12.8" />
        <line x1="3.2" y1="12.8" x2="4.6" y2="11.4" />
        <line x1="11.4" y1="4.6" x2="12.8" y2="3.2" />
      </g>
      <circle cx="8" cy="8" r="2.8">
        {!reduced && (
          <animate attributeName="r" values="2.6;3.2;2.6" dur="2.8s" repeatCount="indefinite" />
        )}
      </circle>
    </Svg>
  );
}
